/**
 * The Mystic tab: it always opens that Mystic's room (navigation-design §1;
 * quest journey 2026-10-27, "the bringing Mystic's tab is there from the
 * start").
 *
 * Prod 2026-10-30: from the Quest it set the panel to '' and dropped ?panel=
 * from the address; the route watcher then landed on the signed-in default
 * (the Altar), which opened The Moon's rite at First Star. Back in place now
 * writes the room's own address (?reader=<sub>).
 */

/**
 * { go: 'welcome' } signed out (Mystic Aida's organic room);
 * { go: 'gift_room' } back to the gift's room;
 * { go: 'here', sub, panel } the room is already loaded behind the panel;
 * { go: 'enter', sub } enter the room (the same way a Mystic's link does).
 */
export function mysticTabAction ({ signedIn = false, inGiftRoom = false, sub = '', currentSub = '', sessionId = '',
  roomSub = '', conversationState = '' } = {}) {
  if (!signedIn) return { go: 'welcome' }
  if (inGiftRoom) return { go: 'gift_room' }
  const s = sub || currentSub || 'iam'
  if (s === currentSub && sessionId && roomSub === s) return { go: 'here', sub: s, panel: conversationState ? 'session' : '' }
  return { go: 'enter', sub: s }
}

const PANEL_KEYS = ['panel', 'tab', 'day', 'studio']

/** A Mystic's room's address: ?reader=<sub>, the panel's keys dropped, the rest kept. */
export function roomQuery (query = {}, sub = '') {
  const q = { ...query }
  for (const k of PANEL_KEYS) delete q[k]
  q.reader = sub
  return q
}

/** The same query (a replace to it changes nothing and fires no route change). */
export function sameQuery (a = {}, b = {}) {
  const ka = Object.keys(a || {})
  const kb = Object.keys(b || {})
  return ka.length === kb.length && ka.every((k) => String(a[k]) === String(b[k]))
}
